<div
  #dropdownEl
  [id]="ppId ? ppId : dropdown.buttonId + '-dropdown'"
  class="dropdown"
  [hidden]="!dropdown?.visible"
  [class.dropdown--hidden]="dropdown?.visibilityHidden"
  [class.dropdown--long]="dropdown?.long"
  [class.dropdown--secondary]="dropdown?.secondary"
  >
  <div>
    <ng-template dropdown-host></ng-template>

    @if (dropdown?.options) {
      <ul class="dropdownList">
        @for (option of dropdown?.options; track option) {
          <li class="dropdownItem" (click)="option.action()">
            {{ option.name }}
          </li>
        }
      </ul>
    }
  </div>
</div>
